const PREFIX = 'ANA_';

const analyticsConstants = {
  FLUSH: PREFIX + 'FLUSH',
  QUEUE: PREFIX + 'QUEUE',
};

export default analyticsConstants;
